import { IconWrapper } from '../runtime';
export default IconWrapper('setup', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6.93575 1.29973H9.06435L9.96904 3.56355C10.2676 3.70604 10.5494 3.87992 10.8105 4.08114L13.2649 3.72718L14.3292 5.57232L12.7085 7.63386C12.7184 7.76353 12.7234 7.87332 12.7234 8.02694C12.7234 8.16104 12.7196 8.25675 12.7121 8.37013L14.3292 10.4272L13.2649 12.2723L10.8691 11.9268C10.584 12.1537 10.2733 12.3476 9.94229 12.503L9.06441 14.6997H6.93581L6.05795 12.503C5.72689 12.3476 5.41616 12.1537 5.13104 11.9268L2.73523 12.2723L1.67093 10.4272L3.28807 8.37018C3.28053 8.25678 3.2767 8.14232 3.2767 8.02694C3.2767 7.89464 3.28174 7.76357 3.29162 7.63392L1.6709 5.57233L2.7352 3.72719L5.18963 4.08115C5.45074 3.87994 5.73252 3.70606 6.03105 3.56358L6.93575 1.29973Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M9.75 8.00596C9.75 8.97336 8.9665 9.75759 8 9.75759C7.0335 9.75759 6.25 8.97336 6.25 8.00596C6.25 7.03856 7.0335 6.25433 8 6.25433C8.9665 6.25433 9.75 7.03856 9.75 8.00596Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});